export const isVue3 = !!import.meta.env.VITE_VUE_3

export const isVue2 = !isVue3

export const DEFAULT_MODEL_EVENT = 'update:modelValue'

export const DIRECTIVE_HOOKS = {
  BEFORE_MOUNT: 'beforeMount',
  UNMOUNTED: 'unmounted',
  UPDATED: 'updated',
}

export const COMPONENT_HOOKS = {
  BEFORE_UNMOUNT: 'beforeUnmount',
}
